import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import RouterPropTypes from 'react-router-prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PanelSectionLoading } from '../../../core/components/styled';
import { Resolver } from '../../../core/components';
import { DocumentTitle } from '../../../common/components';
import { getQueryParams } from '../../../utils/services/queryParams';
import { DISQUALIFIED } from '../../../quote/constants';
import { loadOpportunities } from '../../ducks';
import DisqualifiedOpportunitiesSection from './DisqualifiedOpportunitiesSection';

class DisqualifiedOpportunitiesSectionResolver extends PureComponent {
  resolve = () => {
    const {
      loadOpportunities,
      location: { search },
    } = this.props;
    const { page, limit, sortedBy, sortOrder } = getQueryParams(search);
    return loadOpportunities(DISQUALIFIED, page, limit, sortedBy, sortOrder);
  };

  render() {
    return (
      <>
        <DocumentTitle>Disqualified Opportunities</DocumentTitle>
        <Resolver
          successComponent={DisqualifiedOpportunitiesSection}
          loadingComponent={PanelSectionLoading}
          resolve={this.resolve}
        />
      </>
    );
  }
}

DisqualifiedOpportunitiesSectionResolver.propTypes = {
  loadOpportunities: PropTypes.func.isRequired,
  location: RouterPropTypes.location.isRequired,
};

const mapDispatchToProps = { loadOpportunities };

export default withRouter(
  connect(
    undefined,
    mapDispatchToProps,
  )(DisqualifiedOpportunitiesSectionResolver),
);
